import { isFunction, union, chain } from 'underscore';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';

export const StandardControlAdapter = ({ functionToInject = 'onChange', functionsToInject = ['onChange'] } = {}) => (WrappedComponent) => {
  const finalFunctionsToInject = union([functionToInject], functionsToInject);
  const HOC = ({ serverErrorAdapterProps, ...restProps }) => {
    const { onChange } = serverErrorAdapterProps;
    const injectedProps = useMemo(
      () => chain(finalFunctionsToInject)
        .map(funcName => [funcName, (...args) => {
          if (isFunction(restProps[funcName])) {
            restProps[funcName](...args);
          }
          onChange();
        }])
        .object()
        .value(),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [onChange, ...chain(restProps).pick(finalFunctionsToInject).values().value()]
    );

    return <WrappedComponent {...restProps} {...injectedProps} />;
  };

  HOC.propTypes = {
    [functionToInject]: PropTypes.func,
    serverErrorAdapterProps: PropTypes.shape({
      onChange: PropTypes.func.isRequired,
    }).isRequired,
  };

  HOC.defaultProps = {
    [functionToInject]: undefined,
  };

  HOC.displayName = `StandardControlAdapter(${getDisplayName(WrappedComponent)})`;
  hoistNonReactStatics(HOC, WrappedComponent);

  return HOC;
};
